/**
 * Browser polyfills for Node.js APIs
 *
 * Required for libraries like pino that expect Node.js globals
 */

import { Buffer } from 'buffer';

// Inject Buffer into global scope
if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
  window.global = window;
}
